export default "__VITE_ASSET__y_m4wzAf__"